// removed by extract-text-webpack-plugin
module.exports = {"project_add_provider":"project_add_provider","project_add_provider_input":"project_add_provider_input","project_options":"project_options","project_options_row":"project_options_row","project_options_provider":"project_options_provider","project_options_provider_column":"project_options_provider_column","project_options_speed_slider":"project_options_speed_slider","project_options_title":"project_options_title","dark":"dark","inputWrapper":"inputWrapper","icon_wrapper":"icon_wrapper","ant-menu":"ant-menu","project_options_provider_toggle_left":"project_options_provider_toggle_left"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ProjectOptions/style.scss
// module id = 1352
// module chunks = 0